const StyleAdmin = {
  defaultSetting: {
    textCenter: { textAlign: 'center' }
  },
  companyDetail: {
    addButton: {
      bottomSpace: { marginBottom: '3px' }
    }
  }

}
export default StyleAdmin



// WEBPACK FOOTER //
// ./src/admin/style/StyleAdmin.js